import React from "react";
import {
  Container,
  CardBody,
  BenefitContainer,
  Benefits,
  Benefit,
  Item,
  CustomButtom,
  ButtonWrapper,
} from "./styles";
import { eventTrack } from "src/components/GoogleTagManager";

function CardResponsivo({ item }) {
  const scrollToOffer = () => {
    const el = document.querySelector("#plans");
    const yOffset = -120;
    const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;

    window.scrollTo({ top: y, behavior: "smooth" });
  };

  return (
    <Container>
      <CardBody>
        <Benefits>
          {item.map((i, index) => (
            <Item key={item.text} index={index}>
              <img
                src="/bradescoprime/assets/check.svg"
                alt="check"
                style={{
                  paddingLeft: "0.875rem",
                }}
              />
              <BenefitContainer>
                <Benefit>
                  <p>{i.text}</p>
                </Benefit>
              </BenefitContainer>
            </Item>
          ))}
        </Benefits>
        <ButtonWrapper>
          <CustomButtom
            className="botaoTagVeloe"
            color="primary"
            label={"Peça já"}
            onClick={() => {
              scrollToOffer();
              eventTrack(
                'veloe:institucional',
                'clique:botao',
                'motivos-para-usar:peca-ja'
              );
            }}
            style={{
              backgroundColor: "#000",
              color: "#fff",
            }}
          />
        </ButtonWrapper>
      </CardBody>
    </Container>
  );
}

export default CardResponsivo;
